import React from 'react'
import { Text, TextSizes } from '@afterpaytouch/core'
import styles from './style.module.css'

export interface ApiErrors {
  topazErrors?: string
  threeDSErrors?: string
  creditCardServiceErrors?: string
}

interface ErrorMessageProps {
  errors: ApiErrors
  displayErrors: boolean
  textSize: TextSizes
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ errors, displayErrors, textSize }) => {
  if (!displayErrors) {
    return null
  }

  const { topazErrors, threeDSErrors, creditCardServiceErrors } = errors

  const renderErrorMessages = (): React.ReactNode => {
    if (topazErrors !== undefined) {
      return (
        <Text size={textSize} data-testid={'topaz-error'}>
          {topazErrors}
        </Text>
      )
    }
    if (creditCardServiceErrors !== undefined) {
      return <Text size={textSize}>{creditCardServiceErrors}</Text>
    }
    if (threeDSErrors !== undefined) {
      return (
        <Text size={textSize} data-testid={'three-ds-error'}>
          {threeDSErrors}
        </Text>
      )
    }
    return null
  }

  return (
    <div className={styles.formErrors} data-testid='form-errors'>
      {renderErrorMessages()}
    </div>
  )
}
